export const UPDATE_INTERVAL_MS = 10 * 60 * 1000;
export const UPDATE_MIN_INTERVAL_MS = 60 * 1000;
export const WORKER_WAIT_MS = 8 * 1000;
export const UPDATE_SNOOZE_MS = 60 * 60 * 1000;
export const MANDATORY_SNOOZE_MS = 15 * 60 * 1000;

export function isUpdateContextBlocked(prod: boolean, host: string, framed: boolean, swOff: boolean) {
  host = host.toLowerCase();
  const labels = host.split('.');
  const lovableDomain = /\.(lovable\.app|gpt-eng\.com|gptengineer\.run)$/.test(host);
  return !prod || framed || swOff ||
    (lovableDomain && (/^(?:id-preview|preview)(?:-[a-z0-9]+)?--.+$/.test(labels[0]) || /^project--.+-dev$/.test(labels[0]))) ||
    /(^|\.)(lovableproject\.com|lovableproject-dev\.com|beta\.lovable\.dev)$/.test(host);
}

export function shouldCheckUpdate(last: number, now: number) {
  return last === 0 || now - last >= UPDATE_MIN_INTERVAL_MS;
}

export function snoozeDeadline(mandatory: boolean, now: number) {
  return now + (mandatory ? MANDATORY_SNOOZE_MS : UPDATE_SNOOZE_MS);
}

/** Espera real pela instalação do SW novo (baixa todo o precache no celular). */
export const WORKER_INSTALL_WAIT_MS = 60 * 1000;
export const CONTROLLER_WAIT_MS = 10 * 1000;
export const RECOVERY_MAX_ATTEMPTS = 2;
export const RECOVERY_AFTER_MS = 15 * 60 * 1000;
/** Atrasado há mais disso: o "Depois" de 1 h deixa de valer. */
export const STALE_BUILD_IGNORE_SNOOZE_MS = 24 * 60 * 60 * 1000;

export type RecoveryRecord = { target: string; attempts: number; firstAt: number; cleanedAt?: number };

/** Limpeza automática: build publicado ≠ carregado, após N tentativas, X minutos ou SW novo com falha; uma vez por build alvo. */
export function shouldAutoRecover(
  rec: RecoveryRecord | null, remoteBuild: string | null, currentBuild: string, now: number, workerFailed: boolean,
): boolean {
  if (!remoteBuild || remoteBuild === currentBuild) return false;
  if (!rec || rec.target !== remoteBuild || rec.cleanedAt) return false;
  return workerFailed || rec.attempts >= RECOVERY_MAX_ATTEMPTS || now - rec.firstAt >= RECOVERY_AFTER_MS;
}
